(function () {
  'use strict';

  angular
      .module('tf.retailer.Util')
      .factory('ngUtil', ngUtil);

  // @ngInject
  function ngUtil() {
    return {
      eventBinder: eventBinder
    };

    function eventBinder($scope) {
      var eventBindings = [];

      $scope.$on('$destroy', function () {
        angular.forEach(eventBindings, function (binding) {
          binding.$el.off(binding.event, binding.fn);
        });
      });

      return on;

      function on($el, event, fn) {
        eventBindings.push({
          $el : $el,
          event : event,
          fn : fn
        });
        $el.on(event, fn);
      }
    }
  }

})();
